import { render } from "./blankpage.vue?vue&type=template&id=45b0b9ab"
import script from "./blankpage.vue?vue&type=script&lang=js"
export * from "./blankpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__